import { store } from '@wordpress/interactivity';

const getInitialState = () => {
	// Gracefully handle environments where localStorage is not available.
	if ( typeof localStorage === 'undefined' ) {
		return { recent_searches: [] };
	}
	const savedRecentSearches = localStorage.getItem( 'recentSearches' );
	return {
		recent_searches: savedRecentSearches
			? JSON.parse( savedRecentSearches )
			: [],
	};
};

const { state, actions } = store( 'instantSearch', {
	state: {
		...getInitialState(),
		/**
		 * Determines if the recent searches should be visible.
		 * This is derived state, so it's a getter.
		 */
		get isAnyRecentSearches() {
			return (
				state.recent_searches?.length > 0 &&
				( ! state.search || state.search.length === 0 )
			);
		},
	},
	actions: {
		/**
		 * Removes a single item from the recent searches list.
		 *
		 * @param {string} url The URL of the item to remove.
		 */
		removeRecentSearch( url ) {
			if ( ! url ) {
				console.error( 'URL is missing.' );
				return;
			}

			// Filter the array without needing to access the DOM.
			const newRecentSearches = state.recent_searches.filter(
				( search ) => search.url !== url
			);

			// Update state and localStorage.
			state.recent_searches = newRecentSearches;
			localStorage.setItem(
				'recentSearches',
				JSON.stringify( newRecentSearches )
			);
		},

		/**
		 * Clears all recent searches.
		 */
		clearRecentSearches() {
			state.recent_searches = [];
			localStorage.removeItem( 'recentSearches' );
		},
	},
} );
